import { URI } from '@/config/config'

export default async ({ rootState }, { licencePlate }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;

  const opts = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ licencePlate })
  }
  try {
    const userLoginInfoResult = await fetch(`${URI}vehicle/reset-continuity`, opts)
    const resultJson = await userLoginInfoResult.json()
    return resultJson.data
  } catch(error) {
    return Promise.reject(error)
  }
}